import { cloneDeep, findIndex } from "lodash";
import {
  EDIT_SETTINGS_SUCCESS,
  GET_SETTINGS_FAILED,
  GET_SETTINGS_SUCCESS,
  GET_USER_DETAILS_ID_SUCCESS,
} from "../constants";

export const initialState = {
  settings: undefined,
  userDetails: undefined,
};
export const SettingReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SETTINGS_SUCCESS:
      return {
        ...state,
        settings: action.payload,
      };
    case GET_SETTINGS_FAILED:
      return {
        ...state,
        settings: undefined,
      };
    case GET_USER_DETAILS_ID_SUCCESS: {
      return {
        ...state,
        userDetails: action.payload,
      };
    }

    case EDIT_SETTINGS_SUCCESS:
      const tempUserUpdateDetails = cloneDeep(state.settings);
      const index = findIndex(tempUserUpdateDetails.data, {
        _id: action.payload.id,
      });
      if (index !== -1) {
        const updatedObj = { ...action.payload, _id: action.payload.id };
        tempUserUpdateDetails.splice(index, 1, updatedObj);
      }
      return {
        ...state,
        settings: tempUserUpdateDetails,
      };

    default:
      return state;
  }
};
